import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";

interface CaseHeroLogoProps {
  open: boolean;
}

export const CaseHeroLogo = ({ open }: CaseHeroLogoProps) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1.5,
      }}
    >
      {/* Superhero Cape Icon */}
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <linearGradient id="capeGradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor={theme.palette.primary.main} />
            <stop offset="100%" stopColor={theme.palette.secondary.main} />
          </linearGradient>
        </defs>
        {/* Cape / Shield Shape */}
        <path
          d="M16 2L4 8V16C4 22.627 9.373 28 16 30C22.627 28 28 22.627 28 16V8L16 2Z"
          fill="url(#capeGradient)"
          opacity="0.9"
        />
        {/* Inner cape detail */}
        <path
          d="M16 6L8 10.5V16C8 20.418 11.582 24 16 25.5C20.418 24 24 20.418 24 16V10.5L16 6Z"
          fill={theme.palette.background.paper}
          opacity="0.3"
        />
        {/* Hero star/emblem */}
        <path
          d="M16 10L17.5 14.5L22 14.5L18.5 17.5L20 22L16 19L12 22L13.5 17.5L10 14.5L14.5 14.5L16 10Z"
          fill={theme.palette.background.paper}
        />
      </svg>

      {/* Wordmark - only visible when open. Solid, so the coloured
          mark stays the single accent in the brand block. */}
      {open && (
        <Typography
          sx={{
            fontSize: "1.0625rem",
            fontWeight: 700,
            letterSpacing: "-0.02em",
            color: "text.primary",
            whiteSpace: "nowrap",
          }}
        >
          CaseHero
        </Typography>
      )}
    </Box>
  );
};